/**
 * Theme Initializer
 *
 * This script runs synchronously before the page renders to prevent
 * Flash of Unstyled Content (FOUC) when using dark mode.
 *
 * It must be loaded WITHOUT the defer attribute to ensure it executes
 * before the browser paints the page.
 */

const defaultThemeMode = "light"
let themeMode: string | null = defaultThemeMode

if (document.documentElement) {
  if (document.documentElement.hasAttribute("data-bs-theme-mode")) {
    themeMode = document.documentElement.getAttribute("data-bs-theme-mode")
  } else {
    try {
      const storedTheme = localStorage.getItem("data-bs-theme")
      if (storedTheme !== null) {
        themeMode = storedTheme
      }
    } catch {
      // localStorage may be unavailable in private browsing
    }
  }

  if (themeMode === "system") {
    themeMode = window.matchMedia("(prefers-color-scheme: dark)").matches
      ? "dark"
      : "light"
  }

  document.documentElement.setAttribute("data-bs-theme", themeMode || defaultThemeMode)
}
